// websocket.js
import { EventBus } from './eventBus';

class WebSocketManager {
  constructor() {
    this.connection = null;
    this.hubProxy = null;
    this.userInfo = null;

    // 不自动检查登录，改为监听路由变化或手动调用
    this.init();
  }

  init() {
    // 监听登录事件
    EventBus.$on('user-login', (userInfo) => {
      this.connect(userInfo);
    });

    // 监听登出事件
    EventBus.$on('user-logout', () => {
      this.disconnect();
    });

    // 监听页面加载完成事件（可选）
    window.addEventListener('load', () => {
      // 页面刷新时不做自动连接，等待用户操作
    });
  }

  // 手动调用连接（可以在需要的时候调用）
  connectIfNeeded() {
    const userCode = localStorage.getItem('UserCode');
    const userId = localStorage.getItem('UserId');

    // 只有确实需要连接时才连接
    if (userCode && userId && !this.connection) {
      console.log('检测到已登录，建立WebSocket连接');
      this.connect({ userCode, userId });
    }
  }

  connect(userInfo) {
    // 如果已经连接，先断开
    if (this.connection) {
      this.disconnect();
    }

    this.userInfo = userInfo;
    this.connection = $.hubConnection(SZH.assets.ws, {});
    this.hubProxy = this.connection.createHubProxy("NoticeHub");

    this.hubProxy.on("receiveMessage", (data) => {
      EventBus.$emit('ws-message', data);
    });

    this.connection.start().done(() => {
      this.hubProxy.invoke('Join', userInfo.userCode, userInfo.userId);
      console.log('WebSocket连接成功');
    }).fail((err) => {
      console.error('连接失败', err);
    });
  }

  disconnect() {
    if (this.connection) {
      this.connection.stop();
      this.connection = null;
      this.hubProxy = null;
      console.log('WebSocket已断开');
    }
  }
}

export default new WebSocketManager();



// WEBPACK FOOTER //
// ./src/utils/websocket.js